import { render } from "./TheFooter.vue?vue&type=template&id=66657702&ts=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=66657702&lang=css"

import exportComponent from "C:\\Users\\agui4\\Documents\\projects\\caner-server-status\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__